<template>
  <div class="login-page">
    <Login />
  </div>
</template>

<script>
import { Login } from '@/features/login';

export default {
  components: { Login },
};
</script>
